import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React from 'react';
import request from '../request';

var useContactSchema = function useContactSchema() {
  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var _React$useState3 = React.useState(true),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      loading = _React$useState4[0],
      setLoading = _React$useState4[1];

  var _React$useState5 = React.useState(null),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      error = _React$useState6[0],
      setError = _React$useState6[1];

  React.useEffect(function () {
    setLoading(true);
    setError(null);
    request({
      url: '/backend/schema/contact'
    }).then(function (response) {
      setError(null);
      setValue(response);
      setLoading(false);
    }).catch(function (err) {
      setError(err);
      setLoading(true);
    });
  }, []);
  return {
    loading: loading,
    error: error,
    value: value
  };
};

export default useContactSchema;